export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">精选推荐</h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
              每日精选妖精视频、桃花视频等平台优质资源，热门视频合集一网打尽
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {/* Card 1 */}
            <div className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-video bg-background-200 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20video%20player%20interface%20mockup%20on%20dark%20background%20with%20warm%20accent%20lighting%2C%20cinematic%20frame%2C%20elegant%20design%2C%20professional%20quality%2C%20warm%20coral%20tones&width=800&height=450&seq=media-card-01&orientation=landscape"
                  alt="妖精视频本周热门精选合集"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
                    热门推荐
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 flex items-center gap-1 text-background-50 text-xs font-medium bg-black/40 rounded-full px-2.5 py-1">
                  <i className="ri-star-fill text-accent-400"></i>
                  <span>9.2</span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center shadow-lg">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug line-clamp-2">
                  妖精视频本周热门精选合集
                </h3>
                <div className="flex items-center gap-4 mt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    28.6万次浏览
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    今日更新
                  </span>
                </div>
              </div>
            </div>

            {/* Card 2 */}
            <div className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-video bg-background-200 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20film%20reel%20and%20digital%20media%20collage%20with%20warm%20amber%20tones%2C%20artistic%20composition%2C%20soft%20shadows%2C%20editorial%20photography%20style%2C%20high%20detail%2C%20cinematic&width=800&height=450&seq=media-card-02&orientation=landscape"
                  alt="桃花视频独家影视大全专题"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-accent-500 text-background-50 whitespace-nowrap">
                    独家专题
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 flex items-center gap-1 text-background-50 text-xs font-medium bg-black/40 rounded-full px-2.5 py-1">
                  <i className="ri-star-fill text-accent-400"></i>
                  <span>8.9</span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center shadow-lg">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug line-clamp-2">
                  桃花视频独家影视大全专题
                </h3>
                <div className="flex items-center gap-4 mt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    15.2万次浏览
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    昨日更新
                  </span>
                </div>
              </div>
            </div>

            {/* Card 3 */}
            <div className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-video bg-background-200 overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Streaming%20entertainment%20platform%20thumbnail%20with%20gradient%20overlay%2C%20modern%20UI%20elements%2C%20warm%20color%20palette%2C%20professional%20visual%20design%2C%20cinematic%20mood%2C%20coral%20and%20gold&width=800&height=450&seq=media-card-03&orientation=landscape"
                  alt="苹果视频+榴莲视频双平台好片"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-secondary-600 text-background-50 whitespace-nowrap">
                    双平台
                  </span>
                </div>
                <div className="absolute bottom-3 right-3 flex items-center gap-1 text-background-50 text-xs font-medium bg-black/40 rounded-full px-2.5 py-1">
                  <i className="ri-star-fill text-accent-400"></i>
                  <span>9.5</span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center shadow-lg">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug line-clamp-2">
                  苹果视频+榴莲视频双平台好片
                </h3>
                <div className="flex items-center gap-4 mt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    22.1万次浏览
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    今日更新
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}